import {Component} from "react";
import React from "react";
import {Col, ControlLabel, Form, FormControl, FormGroup, Row} from "react-bootstrap";
import {TopButtonCancel, TopButtonSave} from "../../../../componentsTopsa/buttons/TopButtons";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import Validator from "../../../../utilities/Validator";

export default class PracownicyForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pracownik:{
                "email": "",
                "idPr": null,
                "imie": "",
                "nazwisko": ""
            },
            err:null
        };
        this.onChangeValue = this.onChangeValue.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
    }

    componentDidMount(){
        this.ustawEdytowanego(this.props)
    }

    componentWillReceiveProps(np){
        this.ustawEdytowanego(np)
    }

    ustawEdytowanego(props){
        if(props.edytowany){
            this.setState({pracownik:props.edytowany})
            document.getElementById('inputI').value = props.edytowany.imie
            document.getElementById('inputN').value = props.edytowany.nazwisko
            document.getElementById('inputE').value = props.edytowany.email
        }
    }

    onChangeValue(key,e){
        if(key ==='email'){
            if(Validator.validateLenghtWithClearing(e.target.value,200,'inputE',this.state.pracownik[key])){
                let obj = this.state.pracownik
                obj[key] = e.target.value
                this.setState({pracownik:obj})
            }
        }
        else if(key==='imie'){
            if(Validator.validateLenghtWithClearing(e.target.value,100,'inputI',this.state.pracownik[key])){
                let obj = this.state.pracownik
                obj[key] = e.target.value
                this.setState({pracownik:obj})
            }
        }
        else if(key==='nazwisko'){
            if(Validator.validateLenghtWithClearing(e.target.value,100,'inputN',this.state.pracownik[key])){
                let obj = this.state.pracownik
                obj[key] = e.target.value
                this.setState({pracownik:obj})
            }
        }
        else{
            let obj = this.state.pracownik
            obj[key] = e.target.value
            this.setState({pracownik:obj})
        }

    }

    onClickZapisz(){
        if(this.state.pracownik.imie.length>0 && this.state.pracownik.nazwisko.length>0 && this.state.pracownik.email.length>0){
            this.props.handleClickZapisz(this.state.pracownik,Boolean(this.props.edytowany))
        }
        else this.setState({err:'Należy uzupełnić wszystkie pola'})
    }

    render() {

        return (
            <div>
                <fieldset>
                    <div className={'fieldset-label'}>{Boolean(this.props.edytowany) ? 'Edycja pracownika' : 'Nowy pracownik'}</div>
                    <Form horizontal={true}>
                        <FormGroup>
                            <Col xs={12} lg={2}>
                                <ControlLabel>
                                    Imie <span className={'req'}>*</span> <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.pracownik.imie.length}/100 znaków</span>
                                </ControlLabel>
                                <FormControl onChange={(e)=>this.onChangeValue('imie',e)} id={'inputI'}/>
                            </Col>
                            <Col xs={12} lg={2}>
                                <ControlLabel>
                                    Nazwisko <span className={'req'}>*</span> <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.pracownik.nazwisko.length}/100 znaków</span>
                                </ControlLabel>
                                <FormControl  onChange={(e)=>this.onChangeValue('nazwisko',e)} id={'inputN'}/>
                            </Col>
                            <Col xs={12} lg={2}>
                                <ControlLabel>
                                    Email <span className={'req'}>*</span> <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.pracownik.email.length}/10 znaków</span>
                                </ControlLabel>
                                <FormControl  onChange={(e)=>this.onChangeValue('email',e)} id={'inputE'}/>
                            </Col>
                            <Col xs={12} lg={3}>
                                <div className={'add-label-margin'}></div>
                                <TopButtonCancel onClick={() => {
                                    this.props.handleClickAnuluj()
                                }} text={'Anuluj'}/>
                                <TopButtonSave onClick={this.onClickZapisz} text={'Zapisz'}/>
                            </Col>
                            <Col xs={12}>
                                <TopIf isTrue={Boolean(this.state.err)}>
                                    <div style={{color:'firebrick',marginTop:'5px'}}>
                                        <i className={'fa fa-exclamation-circle'}></i> {this.state.err}
                                    </div>
                                </TopIf>
                            </Col>
                        </FormGroup>
                    </Form>
                </fieldset>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/administracja/pracownicy/components/PracownicyForm.js